import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e34be960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-body" }
const _hoisted_2 = { class: "header-layout" }
const _hoisted_3 = { class: "user-menu-c" }

import { h, ref } from "vue";
import { MenuProps } from "ant-design-vue";
import { useStore } from "vuex";
import { UserMenu } from "./index";
import { Menu } from "@/config/config";
import router from "@/router";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const route = useRoute();
const store = useStore();
const routes = store.getters.GET_ROUTE;

// const items = ref<MenuProps["items"]>([]);
const items = ref([]);

routes.map((e: any) => {
  if (e.name in Menu) {
    if (e.children) {
      let newChildren: Array<any> = [];
      e.children.map((foo: any) => {
        newChildren.push({
          key: foo.name,
          label: Menu[foo.name],
          title: Menu[foo.name],
        });
      });
      items.value.push({
        key: e.name,
        label: Menu[e.name],
        title: Menu[e.name],
        children: newChildren,
      });
    } else {
      items.value.push({
        key: e.name,
        label: Menu[e.name],
        title: Menu[e.name],
      });
    }
  }
});

const handleClickMenu: MenuProps["onClick"] = (menuInfo) => {
  router.push({ name: menuInfo.key });
};

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { style: {"display":"flex","align-items":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_image, {
                    src: "https://img.onehome.cn/new-hr-portal/bG9nb%2BeZveiJsg%3D%3D.png",
                    preview: false
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    theme: "dark",
                    class: "menu-c",
                    selectedKeys: [
                _unref(route).name == 'posBatchAdd' || _unref(route).name == 'posBatchReduce'
                  ? 'posList'
                  : _unref(route).name,
              ],
                    mode: "horizontal",
                    items: items.value,
                    onClick: handleClickMenu
                  }, null, 8, ["selectedKeys", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(UserMenu))
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})